import { ArcadaSomenteLeitura } from "@/components/odontograma/ArcadaSomenteLeitura";

/** Odontograma somente-leitura — mostra os dentes de um serviço já salvo (sem seleção/edição). */
export function ProsthesisTeethDisplay({ teeth }: { teeth: string | null | undefined }) {
  return <ArcadaSomenteLeitura dentes={teeth} />;
}
